import { render } from "./StoryAuthorAvatar.vue?vue&type=template&id=b4911d1a&scoped=true"
import script from "./StoryAuthorAvatar.vue?vue&type=script&lang=js"
export * from "./StoryAuthorAvatar.vue?vue&type=script&lang=js"

import "./StoryAuthorAvatar.vue?vue&type=style&index=0&id=b4911d1a&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4911d1a"]])

export default __exports__